import { Component, Injector, OnInit } from '@angular/core';
import { jkGlb, MaterialModule, } from 'jk-service';
import { PageKind, UiModeType, } from 'jk-service';
import { MtrwdService, templateUrlConfigMtr } from './../_service_mtr';
//import { Mtrki01DetailComponent } from './mtrki01-detailPkg.component';
import { MtrwdEditComponent, } from './../_edit_mtr';
import { JackBaseComponentModule } from 'jk-service';
import { jkSingleComponent, JkaggridComponent } from 'jk-advcom';


@Component({
  selector: 'app-mtrki01',
  standalone: true,
  providers: [],
  imports: [
    MaterialModule,
    JackBaseComponentModule,
    JkaggridComponent,
  ],
  templateUrl: './mtrki01Pkg.component.html',
  styleUrls: [],
})
export class Mtrki01Component extends jkSingleComponent implements OnInit {

  override _programId = 'mtrki01';
  constructor() {
    super();
    this.srv = new MtrwdService();
    this.srv.programId = this.programId;

    this.uiMode = UiModeType.dialog;
    this.title = '工作管理建立';
    this.gridInitOpt = { programId: this.programId, sortField: 'WD002', sort: 'desc', defaultSort: null, pageKind: this.pageKind };
    this.qbeConfig.addField = '';
    this.qbeConfig.addWhere = '';
    this.masterEditPage = MtrwdEditComponent;
    this.srv.programId = this.programId; // ###

    //this.constructorInit();
  }

  override onWindowResize($event?: any) {
    super.onWindowResize($event);
  }
  override async constructorInit() {
    await super.constructorInit();
    //this.srv.cdr = this.cdr;
  };


}
